import { render, staticRenderFns } from "./AltaCreditosFull.vue?vue&type=template&id=3ff17fbe"
import script from "./AltaCreditosFull.vue?vue&type=script&lang=js"
export * from "./AltaCreditosFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports